<template>
  <div>
    <div v-if="!editing">
      {{textOnly(data.question.html)}}
    </div>
    <div v-else>
      <div class="row mb-4">
        <div class="col">
          <h5>{{'Question' | translate}}</h5>
          <QuillInputS
            name="question"
            display-name=""
            placeholder=""
            :value="data.question.quill"
            @quillChanged="questionChanged"
          ></QuillInputS>
        </div>
      </div>

      <hr>

      <h5>{{'Possible answers' | translate}}</h5>
      <div class="row" v-for="(answer, index) in data.answers" :key="index">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="mb-3 mb-1">
                <label>{{ 'Answer' | translate}}</label>
                <div class="d-flex flex-row">
                  <input
                    class="form-control"
                    type="text"
                    v-model="answer.label"
                    :placeholder="$t('Answer')"
                  />
                  <button @click="deleteAnswer(index)" class="btn btn-outline-danger ms-3">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
              <div class="mb-3 form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="answer.correct"
                />
                <label class="form-check-label">{{'Correct answer' | translate}}</label>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>

      <div class="row mb-4">
        <div class="col">
          <button class="btn btn-primary" @click.prevent="addAnswer">
            {{'Add answer' | translate}}
          </button>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col">
          <h5>{{'Solution' | translate}}</h5>
          <QuillInputS
            name="solution"
            display-name=""
            placeholder="Solution tips here"
            :value="data.solution.quill"
            @quillChanged="solutionChanged"
          ></QuillInputS>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuillInputS from './../QuillInputS'

export default {
  props: ['component', 'editing'],
  components: {
    QuillInputS,
  },
  data() {
    return {
      data: this.component.data,
    }
  },
  mounted() {},
  updated() {
    this.updatecomponent()
  },
  methods: {
    questionChanged(html, quill) {
      this.data.question.quill = quill
      this.data.question.html = html
    },
    solutionChanged(html, quill) {
      this.data.solution.quill = quill
      this.data.solution.html = html
    },
    deleteAnswer(key) {
      this.$delete(this.data.answers, key)
    },
    addAnswer() {
      this.data.answers.push({
        label: '',
        correct: false,
      })
    },
    updatecomponent() {
      this.component.data = this.data
    },
    textOnly(text) {
        return text
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .substr(0, 200)
    },
  },
}
</script>
